export default {
  Simple: 'Simple',
  SimpleWithSymbols: 'SimpleWithSymbols',
  Particles: 'Particles',
  ParticlesWithSymbols: 'ParticlesWithSymbols',
  Symbols: 'Symbols',
};
